import { AdornedInput, FormField, FormHelp, Label } from '@zillow/constellation-10';

import { MAX_INPUT_LENGTH, formatInputValue } from './renewalVsTurnover';

const FIELD_CSS = {
  gridRow: 'span 3',
  gridTemplateRows: 'subgrid',
  marginBlockEnd: '400',
  '& > .c11n_label': { alignSelf: 'end' },
} as const;

type RenewalVsTurnoverFieldProps = {
  label: string;
  value: string;
  unit: '$' | 'months';
  help?: string;
  error?: string;
  onChange: (value: string) => void;
};

const RenewalVsTurnoverField = ({ label, value, unit, help, error, onChange }: RenewalVsTurnoverFieldProps) => {
  const isCurrency = unit === '$';
  const description = error ?? help;

  return (
    <FormField
      css={FIELD_CSS}
      error={error !== undefined}
      label={<Label>{label}</Label>}
      description={description && <FormHelp>{description}</FormHelp>}
      control={
        <AdornedInput
          input={
            <AdornedInput.Input
              inputMode="decimal"
              maxLength={MAX_INPUT_LENGTH}
              value={value}
              onChange={(event) => onChange(event.target.value)}
              onBlur={() => onChange(formatInputValue(value, isCurrency))}
            />
          }
          startAdornment={isCurrency ? <AdornedInput.Adornment>$</AdornedInput.Adornment> : undefined}
          endAdornment={isCurrency ? undefined : <AdornedInput.Adornment>{unit}</AdornedInput.Adornment>}
        />
      }
    />
  );
};

export default RenewalVsTurnoverField;
